let admin = $('section[data-admin]').length;

if(admin){
  $('footer').addClass('footer__admin');
}



// WEBPACK FOOTER //
// ./assets/js/admin.js